import { toast } from "react-toastify";
import usePaginator from "../../../../../theme/Component/usePaginator";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { useEffect, useState } from "react";
import { BasicTable, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { _single, _UBLNotification } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { SelectUBLNotificationTypeConstants } from "./SelectUBLNotificationTypeConstants";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import useModal, { MODAL_md, MODAL_SM } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { FileService } from "../../../../../../core/services/FileService";

type UBLInvoiceBean = {
    IDUBLInvoice: number,
    IssueDate: any,
    [key: string]: unknown;
}

interface UBLNotificationComponent {
    ublInvoice: UBLInvoiceBean;
}

export const UBLNotification = ({ ublInvoice }: UBLNotificationComponent) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_UBLNotification);
    const _file = new FileService();
    const paginador = usePaginator();

    const [type, setType] = useState<number | undefined>(null);
    const [code, setCode] = useState<string | undefined>(null);
    const [code2, setCode2] = useState<string | undefined>(null);
    const [event,setEvent] = useState<any>({});
    const modal = useModal("Evento",MODAL_md);

    useEffect(() => {
        if (ublInvoice.IDUBLInvoice && ublInvoice.IssueDate) {
            getLista();
        }
    }, [ublInvoice.IDUBLInvoice])

    const getLista = () => {
        instance.getUBLNotificationCatalog(ublInvoice.IDUBLInvoice, ublInvoice.IssueDate, null, code == ''? null : code, paginador.page, 15).then(
            (resp) => {
                console.log(resp);
                resp.List.forEach(element => {
                    element.DataBeanProperties.URL = "<a href=' target='_blank' rel='noopener noreferrer'>"+_file.getUrlFile(
                        element.DataBeanProperties.MediaContext,
                        element.DataBeanProperties.Media
                    )+"'>"+element.DataBeanProperties.Media+"</a>";
                });
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setBean({});
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const sendRadianEvent = () => {
        instance.sendRadianEvent(_single.getAccountID(),ublInvoice.IDUBLInvoice, ublInvoice.IssueDate, code2, {}).then(
            (resp) => {
                toast.success(resp.DianResponse?.StatusMessage);
                setEvent(resp);
                getLista();
                modal.close();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }
    const agregarItem = () => {
        modal.open();
    }

    const head = [
        { title: 'No', property: 'Type', visible: true,mask:MASK_NUMBER },
        { title: 'Codigo', property: 'Code', visible: true },
        { title: 'Descripcion Evento', property: 'Description', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Respuesta DIAN', property: 'URL', visible: true },
        
    ];

     const iconButtonsItem = [
        { nombre: 'Agregar',visible:_single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem },
        
    ]


    return (
        <div className="row">
            {/* <div className="col-md-6">
                <SelectUBLNotificationTypeConstants idSelector={code} onChange={(e) => { setCode(e) }} />
            </div> */}
            {/* <div className="col-md-6">
                <BasicButton icon="ri-seach-line" useMargin eventClick={() => { getLista(); }}>Buscar</BasicButton>
            </div> */}
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    iconButtons={iconButtonsItem}
                    records={paginador}
                />
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={sendRadianEvent} onSubmitLabel="Enviar">
                    <div className="row">
                        <div className="col-md-12">
                            <SelectUBLNotificationTypeConstants idSelector={code2} onChange={(e) => { setCode2(e) }} />
                        </div>
                    </div>
                </Modal>
                {/* <PrintJson json={lista}/>
                <PrintJson json={event}/> */}
            </div>
        </div>
    )
}